const isDev = import.meta.env.DEV;

const logger = {
  log: isDev ? console.log.bind(console) : () => {},
  warn: isDev ? console.warn.bind(console) : () => {},
  error: console.error.bind(console), // zawsze loguj błędy
};

export default logger;
